import React from 'react';
import * as util from '#packages/util';
import styles from './helpChatbotEntry.scss';
import HelpWidget from './helpWidget';
import type { HelpChatbotEntryDispatchProps } from './helpChatbotEntryMapper';
import { mapDispatchToProps } from './helpChatbotEntryMapper';

const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;

const CHATBOT_FULL_PAGE_URL = 'https://wix.com/contact?referral=editor_help';

export interface HelpChatbotEntryOwnProps {
  children?: React.ReactNode;
}

interface HelpChatbotEntryProps
  extends HelpChatbotEntryOwnProps,
    HelpChatbotEntryDispatchProps {}

const HelpChatbotEntry: React.FunctionComponent<HelpChatbotEntryProps> = ({
  children,
  sendBiOnChatbotClick,
}) => {
  const openChatbotFullPage = () => {
    window.open(CHATBOT_FULL_PAGE_URL, '_blank', 'noopener,noreferrer');
    sendBiOnChatbotClick();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openChatbotFullPage();
    }
  };

  return (
    <>
      <div
        className={styles.helpChatbotEntry}
        role="button"
        tabIndex={0}
        onClick={openChatbotFullPage}
        onKeyDown={handleKeyDown}
      >
        {children}
      </div>
      <div className={styles.helpWidgetSdkLoader} aria-hidden="true">
        <HelpWidget />
      </div>
    </>
  );
};

export default connect(
  EDITOR_API,
  undefined,
  mapDispatchToProps,
)(HelpChatbotEntry);
